import * as React from "react";
import type { SVGProps } from "react";
const SvgIconGrid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={512}
    height={512}
    data-name="Layer 1"
    {...props}
  >
    <path
      fill="#242323"
      d="M445.81 285.6H299.52c-10.99 0-19.94 8.94-19.94 19.93v146.3c0 10.99 8.95 19.94 19.94 19.94h146.29c11 0 19.94-8.95 19.94-19.94v-146.3c0-10.99-8.94-19.93-19.94-19.93m.44 166.23c0 .23-.2.43-.44.43H299.52a.44.44 0 0 1-.43-.43v-146.3c0-.23.2-.43.43-.43h146.29c.24 0 .44.2.44.43zM212.48 285.6H66.19c-11 0-19.94 8.94-19.94 19.93v146.3c0 10.99 8.94 19.94 19.94 19.94h146.29c11 0 19.94-8.95 19.94-19.94v-146.3c0-10.99-8.94-19.93-19.94-19.93m.44 166.23c0 .23-.2.43-.44.43H66.19c-.24 0-.44-.2-.44-.43v-146.3c0-.23.2-.43.44-.43h146.29c.24 0 .44.2.44.43zM445.81 40.23H299.52c-10.99 0-19.94 8.94-19.94 19.93v146.3c0 11 8.95 19.94 19.94 19.94h146.29c11 0 19.94-8.94 19.94-19.94V60.16c0-10.99-8.94-19.93-19.94-19.93m.44 166.23c0 .24-.2.43-.44.43H299.52c-.23 0-.43-.19-.43-.43V60.16c0-.23.2-.43.43-.43h146.29c.24 0 .44.2.44.43zM212.48 40.23H66.19c-11 0-19.94 8.94-19.94 19.93v146.3c0 11 8.94 19.94 19.94 19.94h146.29c11 0 19.94-8.94 19.94-19.94V60.16c0-10.99-8.94-19.93-19.94-19.93m.44 166.23c0 .24-.2.43-.44.43H66.19c-.24 0-.44-.19-.44-.43V60.16c0-.23.2-.43.44-.43h146.29c.24 0 .44.2.44.43z"
    />
  </svg>
);
export default SvgIconGrid;
